import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function LanguageToggle() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <motion.div initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 1
  }} style={{
    position: 'fixed',
    bottom: '2rem',
    right: '2rem',
    zIndex: 200,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(8, 8, 8, 0.92)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    border: '1px solid rgba(255,255,255,0.12)',
    overflow: 'hidden'
  }} data-id="element-53">
      <button onClick={() => setLang('en')} style={{
      fontFamily: '"IBM Plex Mono", monospace',
      fontSize: '0.6rem',
      letterSpacing: '0.2em',
      textTransform: 'uppercase',
      color: lang === 'en' ? 'var(--white)' : 'rgba(255,255,255,0.3)',
      backgroundColor: lang === 'en' ? 'rgba(255,255,255,0.08)' : 'transparent',
      border: 'none',
      padding: '0.6rem 0.9rem',
      cursor: 'pointer',
      transition: 'color 0.2s ease, background-color 0.2s ease',
      lineHeight: 1
    }} data-id="element-54">
        EN
      </button>
      <div style={{
      width: '1px',
      height: '1rem',
      backgroundColor: 'rgba(255,255,255,0.12)',
      flexShrink: 0
    }} data-id="element-55" />
      <button onClick={() => setLang('zh')} style={{
      fontFamily: '"IBM Plex Sans", sans-serif',
      fontSize: '0.65rem',
      letterSpacing: '0.05em',
      color: lang === 'zh' ? 'var(--white)' : 'rgba(255,255,255,0.3)',
      backgroundColor: lang === 'zh' ? 'rgba(255,255,255,0.08)' : 'transparent',
      border: 'none',
      padding: '0.6rem 0.9rem',
      cursor: 'pointer',
      transition: 'color 0.2s ease, background-color 0.2s ease',
      lineHeight: 1
    }} data-id="element-56">
        中文
      </button>
    </motion.div>;
}